import {Injectable} from '@angular/core';
import {AssignmentDto, CreateAssignmentDto, UpdateAssignmentDto} from '@shared/dto';
import {AbstractAssignmentService} from "./abstract-assignment.service";

@Injectable({
  providedIn: 'root'
})
export class AssignmentService extends AbstractAssignmentService<AssignmentDto, CreateAssignmentDto, UpdateAssignmentDto> {
}
